import { APICore } from "../apiCore";
import { getGuildApiParams } from "../../Guild/guildUtils";

const api = new APICore();

function getHeaderNavData() {
    return api.get(`/pages/header`);
}

// The Header and the home page both request landing data, so share one request
// and reuse the response briefly (per site: main or guild). Kept short because
// content changes often during QC rounds; a page refresh always fetches fresh.
const LANDING_CACHE_MS = 2 * 60 * 1000;
const landingCache = new Map();

function getLandingPageData() {
  const params = getGuildApiParams();
  const key = params ? `guild-${params.guild}` : "main";
  const cached = landingCache.get(key);

  if (cached && Date.now() - cached.time < LANDING_CACHE_MS) {
    return cached.request;
  }

  const forget = () => {
    if (landingCache.get(key)?.request === request) landingCache.delete(key);
  };

  const request = api.get(`/pages/landing`, params).then(
    (result) => {
      // Don't keep empty responses (e.g. the API interceptor's redirect case)
      if (!result?.data?.GenreList) forget();
      return result;
    },
    (error) => {
      forget();
      throw error;
    },
  );

  landingCache.set(key, { request, time: Date.now() });
  return request;
}

function getGenrePageData(genreSlug: string) {
    return api.get(`/pages/genre/${ genreSlug }`, getGuildApiParams());
}

function getGenreFooterMedia(genreSlug: string) {
    return api.get(`/genre/${ genreSlug }/footer`, getGuildApiParams());
}

function getShowDetailPage(genreSlug: string, showSlug: string) {
  return api.get(`/genre/${ genreSlug }/show/${ showSlug }`, getGuildApiParams());
}

export { getHeaderNavData, getLandingPageData, getGenrePageData, getGenreFooterMedia, getShowDetailPage };